// tslint:disable:no-var-requires no-require-imports
export const settings: string = require("../../../../assets/images/diagram/settings.png");
export const move: string = require("../../../../assets/images/diagram/move.png");
export const cross: string = require("../../../../assets/images/diagram/cross.png");
export const add: string = require("../../../../assets/images/diagram/add.png");
export const pencil: string = require("../../../../assets/images/diagram/pencil.png");
export const wrenchScrewdriver: string = require("../../../../assets/images/diagram/wrench-screwdriver.png");
